import { deepGet } from './CollectionUtils'

export function validateRequired(meta, context) {
  const errors = {}
  Object.keys(meta).filter(k => meta[k].required && !deepGet(k, context)).forEach(k => errors[meta[k].errorMember] = (meta[k].requiredError || 'Required'))
  return errors
}